import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { http } from '@/lib/api/client'

export type ConnectionSource = 'server' | 'app' | 'cp'
export type ConnectionTarget = 'service' | 'internal' | 'website' | 'api'
export type ConnectionDays = 1 | 7 | 30

/** One problem (where from, which host, what kind) over the chosen days. */
export interface ConnectionProblem {
  key: string
  source: ConnectionSource
  target: ConnectionTarget
  host: string
  kind: string
  /** "api.dataforseo.com timed out (from the server)". */
  summary: string
  sample: string | null
  count: number
  today: number
  first_seen_at: string | null
  last_seen_at: string
  alerted_at: string | null
}

export interface ConnectionErrorsResponse {
  data: ConnectionProblem[]
  meta: { days: ConnectionDays; total: number; today: number; keep_days: number }
}

export function useConnectionErrors(days: ConnectionDays) {
  return useQuery({
    queryKey: ['connection-errors', days],
    queryFn: () => http.get<ConnectionErrorsResponse>('/connection-errors', { days }),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  })
}
